
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { PermissionItemProps } from ".";
import { loading, update } from "store/permission";

interface ApiPermissionUpdateInputProps extends PermissionItemProps {
}

type ApiPermissionUpdateOutputProps = OutputBaseProps<{ item: PermissionItemProps; }, ApiPermissionUpdateInputProps>;

export const apiPermissionUpdate = async (data: ApiPermissionUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiPermissionUpdateOutputProps>("/api/permission/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
    }
    return res;
};